<template>
  <div>
    <input v-model.trim="modelo.documento" type="text" class="form-control" placeholder="Documento" style="margin:0">
    <p class="text-primary" style="margin-top:0;margin-bottom:0"> <small>{{msg}}</small> </p>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
import { Validator } from 'simple-vue-validator'

export default {
    props:{ 
      model:Object,
      inscripcion:{type:Object,required:true},
      default:{type:String,required:false,default:null},
      idpais:{type:Object, default:null},
    },
    data () { 
        return {
          isLoading: false,
            timeoutHnd: 0,
            msg:'',
            modelo: {
              documento: null,
            }
        }
    },
    validators: {
      // 'modelo.documento'(value){ return Validator.value(value).required().minLength(7).regex("^[1-9]\\d{5,7}(\\-([A-Z0-9]{1,2}))?$"); },
      'modelo.documento'(value){ return Validator.value(value).required().minLength(7); },
    },
    watch:{ 
      'modelo.documento': function(){
        // 
        if(this.idpais && this.idpais.id == 141 ) {
          let value = this.modelo.documento;
          if(value.endsWith('-')) return;
          if(value.length <= 1) return;
          
          value = value.replace(/[\\-]/g, '');
          
          if (value.length <= 4) {
            value = value.replace(/(.{1})(.{0,3})/, '$1-$2');
          } else {
            value = value.replace(/(.{1})(.{3})(.{0,3})(.{0,4})/, '$1-$2-$3$4');
          }
        
          this.modelo.documento = value;
        }
        // 
        this.model.num_doc=this.modelo.documento;
        if (this.timeoutHnd) { 
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var query = this.modelo.documento;
        var vue = this;
        vue.msg = "Verificando si existe...";
        this.timeoutHnd = setTimeout(function () {
          query = query.trim();
          if(query.length>6) {
            vue.asyncFind(query);

          }else{
            vue.msg = "";
          }
          vue.timeoutHnd = 0;
        }, 1200);      
      },
      'default':function(a){
        if( a == null ) return;
        this.modelo.documento = a;
      },
    },
    methods: {
      parseLabel2( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg+" -- Doc: "+option.num_doc;
        },
        async asyncFind (query) {
            if( this.isLoading ) return;
            this.isLoading = true
            var vue = this;
            var sql = gql`query{ getPersonasSearchNameOrNumDoc(text:"${query}",cursor: 10000000, estado: true){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto } }`;
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
              vue.isLoading = false;
              if( data.data == null ){
                vue.msg = "Error, inicie session nuevamente";
                return;
              }
              window.document.documentElement.scrollTop = 0;
              window.document.body.scrollTop = 0;
              if( data.data.getPersonasSearchNameOrNumDoc ){
                var c = data.data.getPersonasSearchNameOrNumDoc.length;
                if( c >= 1 ){
                  vue.msg = "ERROR: Este documento ya existe."
                  var us = data.data.getPersonasSearchNameOrNumDoc[0];
                  vue.inscripcion.idestudiante = { id:us.id,nombre:vue.parseLabel2(us) }
                  setTimeout(function(){
                    window.$('#collapseExample').collapse('hide')
                  },2000)
                }
                else if( c > 0)
                  vue.msg = c+" coincidencias."
                else 
                  vue.msg = ""

              }else{
                vue.msg = ""
              }
              
            }).catch((error) => {
                window.console.error(error)
                vue.isLoading = false;
                vue.msg = "...";
                vue.$notify( parseJsonError( error,'getPersonasSearchNameOrNumDoc' ) )
            })
        },
        clearAll () {
            this.modelo.intereses = null;
        },
    },
    mounted(){
        
    }
}
</script>